export default "/static/frontend/images/images/55512b74906df3a568ab794be6771940-icon.png";